import { AccountGiftCardsScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <AccountGiftCardsScreen />;
}
